import { Component, OnInit, Input, TemplateRef, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 're-collapsible-group',
    templateUrl: './collapsible-group.component.html',
    styleUrls: ['./collapsible-group.component.scss'],
    standalone: false
})
export class CollapsibleGroupComponent implements OnInit {
  private _isCollapsed = false;

  @Input()
  public get isCollapsed() {
    return this._isCollapsed;
  }
  public set isCollapsed(value) {
    if (this._isCollapsed != value) {
      this.isCollapsedChange.emit(value);
    }
    this._isCollapsed = value;
  }

  @Output()
  public isCollapsedChange = new EventEmitter<boolean>();



  @Input("header")
  public title = "";

  @Input()
  tooltip: string | TemplateRef<any>;

  constructor() { }

  ngOnInit() {
  }

}
